<div class="card-media-widget card">
  <div class="card-header font-semibold text-xl mb-4 text-center">Unsere Streamer</div>
  <p-carousel [value]="images" [numVisible]="3" [numScroll]="3" [circular]="false" [responsiveOptions]="carouselResponsiveOptions">
    <ng-template let-streamer #item>
      <div class="rounded-border m-2 p-4" style="background: rgba(255, 255, 255, 0.7); box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2); border-radius: 12px;">
        <div class="mb-4">
          <div class="relative mx-auto">
            <img [src]="streamer.itemImageSrc"
              [alt]="streamer.alt"
              class="w-full rounded-border" />
          </div>
        </div>
        <div class="mb-4 font-medium">
          {{ streamer.title1 }}
          <div class="flex justify-between items-center mt-4">
            <span>
              @if (streamer.twitchLink) {
                <a
                  (click)="navigateToExternalPage('twitch', streamer.twitchLink)"
                  class="inline-block shadow-2xl rounded-lg overflow-hidden text-center bg-white/90 dark:bg-gray-800/90 cursor-pointer no-underline px-6 py-3 text-orange-500 transition-all duration-300 hover:scale-105 hover:shadow-orange-500/30"
                  style="font-family: 'CarterOne', sans-serif;">
                  <i class="pi pi-twitch mr-2"></i>Twitch
                </a>
              }
              @if (streamer.youtubeLink) {
                <a
                  (click)="navigateToExternalPage('youtube', streamer.youtubeLink)"
                  class="inline-block shadow-2xl rounded-lg overflow-hidden text-center bg-white/90 dark:bg-gray-800/90 cursor-pointer no-underline px-6 py-3 text-orange-500 transition-all duration-300 hover:scale-105 hover:shadow-orange-500/30 ml-2"
                  style="font-family: 'CarterOne', sans-serif;">
                  <i class="pi pi-youtube mr-2"></i>YouTube
                </a>
              }
              @if (streamer.tiktokLink) {
                <a
                  (click)="navigateToExternalPage('tiktok', streamer.tiktokLink)"
                  class="inline-block shadow-2xl rounded-lg overflow-hidden text-center bg-white/90 dark:bg-gray-800/90 cursor-pointer no-underline px-6 py-3 text-orange-500 transition-all duration-300 hover:scale-105 hover:shadow-orange-500/30 ml-2"
                  style="font-family: 'CarterOne', sans-serif;">
                  <i class="pi pi-tiktok mr-2"></i>TikTok
                </a>
              }
              @if (streamer.instagramLink) {
                <a
                  (click)="navigateToExternalPage('instagram', streamer.instagramLink)"
                  class="inline-block shadow-2xl rounded-lg overflow-hidden text-center bg-white/90 dark:bg-gray-800/90 cursor-pointer no-underline px-6 py-3 text-orange-500 transition-all duration-300 hover:scale-105 hover:shadow-orange-500/30 ml-2"
                  style="font-family: 'CarterOne', sans-serif;">
                  <i class="pi pi-instagram mr-2"></i>Instagram
                </a>
              }
            </span>
          </div>
        </div>
      </div>
    </ng-template>
  </p-carousel>
</div>
